import React from 'react';
import { useSimulationPlaybackClock } from '../../hooks/useSimulationPlaybackClock';
import { useRailTransferAnimations } from '../../hooks/useRailTransferAnimations';

/**
 * Hosts the simulation runtime hooks in a leaf that renders nothing.
 *
 * Both hooks subscribe to state the live stream rewrites on every 100 ms batch
 * (server time anchors, rate window, inventory, playback vehicles). When they
 * lived directly in EditorLayout, each batch re-rendered the whole editor tree:
 * Toolbar, Toolbox, the 2D Konva canvas, the 3D scene and every panel. Isolating
 * them here keeps those re-renders to this empty component.
 */
const SimulationRuntimeDrivers: React.FC = () => {
  useSimulationPlaybackClock();
  // Circle-junction turntable + H-connector animations, driven off live
  // playback positions against the local track graph.
  useRailTransferAnimations();
  return null;
};

export default SimulationRuntimeDrivers;
